import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { of } from 'rxjs';
import { ExecutiveResume } from 'src/app/interfaces/executive-resume';
import { Handover } from 'src/app/interfaces/handover';
import { HandoverService } from 'src/app/services/handover.service';
import { EXECUTIVE_RESUME_MOCK } from './executive-resume.mock';

@Component({
  selector: 'app-handover-detail-executive-resume',
  templateUrl: './handover-detail-executive-resume.component.html',
  styleUrls: ['./handover-detail-executive-resume.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HandoverDetailExecutiveResumeComponent implements OnInit {
  @Input() handover: Handover | undefined;

  executiveResume: ExecutiveResume | undefined;
  isLoading = false;

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.loadExecutiveResume();
  }

  // TODO(backend): reemplazar por this.handoverService.getExecutiveResume(this.handover.handoverId) cuando exista el endpoint. Ver executive-resume.mock.ts
  private loadExecutiveResume(): void {
    of(EXECUTIVE_RESUME_MOCK).subscribe((executiveResume: ExecutiveResume) => {
      this.executiveResume = executiveResume;
      this.isLoading = false;
    });
  }

  get statusCards() {
    return this.executiveResume?.statusCards ?? [];
  }

  get blocks() {
    return this.executiveResume?.blocks ?? [];
  }
}
